@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  > * {
    font-size: 14px;
    color: @user-avatar-and-name--text-color;
  }
}

.avatar {
  margin-right: 10px;
}
